<template>
  <div class="d-flex align-items-start mb-3">
    <div class="message-avatar me-2">
      <div class="bot-avatar">
        <i class="ri-robot-line"></i>
      </div>
    </div>
    <div class="message-bubble bot-bubble">
      <div class="message-header small mb-1">
        <span class="fw-bold">AI 어시스턴트</span>
      </div>
      <div class="typing-animation">
        <span class="dot"></span>
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatTypingIndicator'
};
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-avatar {
  flex-shrink: 0;
}

.bot-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: #6c757d;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.message-bubble {
  max-width: 70%;
  border-radius: 16px;
  padding: 2px;
  animation: fadeIn 0.3s ease-out;
}

.bot-bubble {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-top-left-radius: 4px;
}

.message-header {
  padding: 4px 12px 0 12px;
}

.typing-animation {
  padding: 8px 12px 10px;
  display: inline-flex;
  align-items: center;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #adb5bd;
  margin: 0 3px;
  animation: bounce 1.4s infinite ease-in-out;
}

.dot:nth-child(1) {
  animation-delay: 0s;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0%, 60%, 100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-5px);
  }
}
</style>
